import React from "react";

export const sliceNames = Object.freeze({
    LOGIN: "login",
    ORDER: "order",
    GLOBAL: "global",
})

export const PageControl = [
    {
        "constant": "TOP",
        "value": "Top"
    },
    {
        "constant": "BOTTOM",
        "value": "Bottom"
    },
    {
        "constant": "BOTH",
        "value": "Both"
    }
]

export const LinkOpeningStyle = [
    {
        "constant": "CURRENT TAB",
        "value": "Current Tab"
    },
    {
        "constant": "NEW TAB",
        "value": "New Tab"
    }

]

export let booleanDrop = [
    { value: true, label: "True" },
    { value: false, label: "False" }
]

export interface ModalProps {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
}
export const phoneTitle = "";
export const phonePattern = "^(\\([0-9]{3}\\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$";
export const remitDefault = "TitleLogix Solutions ATTN: 3rd Floor 1401 S Boulder Ave Tulsa, OK 74119 918-250-1641";
let date = new Date(), y = date.getFullYear(), m = date.getMonth();
export const currentMonthLastDate = new Date(y, m + 1, 0);
export const nextMonthLastDate = new Date(y, m + 2, 0);
let currentTaxYear = new Date().getMonth() < 9 ? new Date().getFullYear() - 1 : new Date().getFullYear();
export const minYear = 1900
export const maxYear = currentTaxYear + 2
export let addNewDefaultSelectorValue = { id: "defaultId", sequence: "", addressLine1: "Add New" };
export let feeListEnabledEnumsRegex = /ASSESSMENT|MAINTENANCE|MAINT_DV_BD_PRO_RATE|MAINT_HO_PRO_RATE|GATE_DV_BD_PRO_RATE|GATE_HO_PRO_RATE/;
export let quickFilterParams = {"quickFilterKey": "quickFilters", "resetQuickFilterKey": "resetQuickFilter"};
export const postalPattern = "^[0-9]{5}(?:-[0-9]{4})?$";
